export default "__VITE_ASSET__C0FFn3N4__"